// @flow

export const CANCEL_BUTTON_FOCUS_KEY = 'CANCEL_BUTTON_FOCUS_KEY'
export const APPROVE_BUTTON_FOCUS_KEY = 'APPROVE_BUTTON_FOCUS_KEY'
